import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable.jsx";
import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import { columns, searchBy } from "./Column.js";
import AddDeliveryType from "./AddDeliveryType.jsx";
import { MasterApi } from "../../../../App/api/setting.js";

const DeliveryType = ({meta, disabledFilters }) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const handlePagination = (data) => {
    // console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      // copyfilter[]

      if (data.filter) {
        // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
        // console.log("Object.keys[copyfilter]",Object.keys(data.filter))

        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const { value, fetchAllData } = useFetchAll(() =>
    MasterApi.master.getAllDeliveryType(pagination, search)
  );

  const [selectedDeliveryType, setSelectedDeliveryType] = useState(null);
  const [addRoleModalOpen, setAddRoleModalOpen] = useState(false);
  const [editDeliveryTypePermissions, setEdityDeliveryTypePermissions] =
    useState(null);

  const closeRoleModal = () => {
    setAddRoleModalOpen(false);
    setEdityDeliveryTypePermissions(null);
  };

  const handleRowClick = (row) => {
    setSelectedDeliveryType(row);
    setAddRoleModalOpen(true);
  };

  const handleCellClick = (cell, field = "") => {
    if (field === "name") {
      setEdityDeliveryTypePermissions(cell);
      setAddRoleModalOpen(true);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination(clearPagination);
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }
    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={value?.data?.deliveryTypes || []}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: value?.data?.page || 1,
          rows: value?.data?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: value?.data?.totalPages || 1,
          totalCount: value?.data?.totalCount || 1,
        }}
        onCellClick={(e) => console.log("Cell Data", e)}
        handleSearch={debouncedSearch}
        SearchBy={searchBy}
        handleFilter={handleFilter}
        handleClearFilter={handleClearFilter}
        selectedData={selectedDeliveryType}
        handleCellClick={handleCellClick}
        button_name="Add Delivery Type"
        handleButton={() => {
          setAddRoleModalOpen(true);
        }}
      />
      <AddDeliveryType
        getAllData={fetchAllData}
        currentItems={editDeliveryTypePermissions}
        open={addRoleModalOpen}
        handleClose={closeRoleModal}
      />
    </div>
  );
};

export default DeliveryType;
